import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    let requestOrigin: string;
    try {
      requestOrigin = new URL(request.url, window.location.origin).origin;
    } catch {
      return next.handle(request);
    }

    if (requestOrigin !== window.location.origin) {
      return next.handle(request);
    }

    return next.handle(request.clone({ withCredentials: true }));
  }
}
